import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { Res, Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		printLastInvoice: () => Promise<Result>
	}
}

Command.register('printLastInvoice', Preconditions.ensure(Permission.Ticket_PrintCopy), async (): Promise<Result> => {

	const lastClosedInvoice = SalesStore.getLastClosedInvoice();
	if (!lastClosedInvoice) {
		await Message.show(Res.Msg.MSG_THERE_ARE_NOT_INVOICES_SINCE_DAY_WAS_OPENED());
		return Result.error();
	}

	await SalesStore.printInvoice(lastClosedInvoice.invoiceId);
	return Result.ok();
});